<div class="custom-toast">
    <div class="custom-toast_icon" [class.open]="isOpen">
        <dsn-button-rounded
            type="secondary"
            [icon]="
                isOpen ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up'
            "
            (click)="toggleToast()"
        ></dsn-button-rounded>
    </div>

    @if (isClosed) {
        <div class="custom-toast_header">
            <i class="far fa-comment-alt"></i>
            <span class="custom-toast_header-title">Enviar feedback</span>
        </div>
    }

    @if (isOpen) {
        <div class="custom-toast_container">
            <div class="report-feedback-component" fxLayout="column">
                <h1 class="report-feedback-component_title" style="margin: 0">
                    Enviar feedback
                </h1>

                <p
                    class="report-feedback-component_description"
                    style="margin: 0"
                >
                    Referente a este Dash, o que achou da performance da
                    empresa?
                </p>

                <div class="report-feedback-component_container">
                    <p class="report-feedback-component_container-title">
                        Escolha de 1 a 5 estrelas para avaliar
                    </p>
                    <div class="report-feedback-component_container-stars">
                        @for (star of stars; track $index; let i = $index) {
                            <i
                                [class]="star ? 'fas fa-star' : 'far fa-star'"
                                (click)="selectStar(i)"
                            ></i>
                        }
                    </div>

                    <p class="report-feedback-component_container-subtitle">
                        {{
                            starsSelected <= 3
                                ? "Do que você não gostou?"
                                : "Do que você gostou?"
                        }}
                    </p>
                    <div class="report-feedback-component_container-chips">
                        @for (chip of chipItems; track chip; let i = $index) {
                            <dsn-chips
                                [label]="chip.label"
                                [selected]="chip.selected"
                                (click)="selectChip(i)"
                            ></dsn-chips>
                        }
                    </div>
                </div>
                <div class="report-feedback-component_container-textarea">
                    <p
                        class="report-feedback-component_container-textarea_title"
                    >
                        Deixe um comentário para sua contabilidade
                    </p>
                    <dsn-textarea
                        [placeholder]="
                            'Ex.: gostaria de marcar uma reunião dia X'
                        "
                        [disabled]="false"
                        [isInvalid]="false"
                        [invalidMessage]="'Este campo e obrigatorio!'"
                        [rows]="5"
                        [cols]="35"
                        [(ngModel)]="commentText"
                        style="width: 100%"
                    ></dsn-textarea>
                </div>
                <div class="report-feedback-component_container-button">
                    <dsn-button
                        [label]="'Enviar para contabilidade'"
                        [disabled]="!starsSelected"
                        (click)="sendFeedback()"
                    ></dsn-button>
                </div>
            </div>
        </div>
    }
</div>
